import { render, staticRenderFns } from "./ms-check-detail.vue?vue&type=template&id=51da59ea&scoped=true"
import script from "./ms-check-detail.vue?vue&type=script&lang=js"
export * from "./ms-check-detail.vue?vue&type=script&lang=js"
import style0 from "./ms-check-detail.vue?vue&type=style&index=0&id=51da59ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da59ea",
  null
  
)

export default component.exports